export default new Intl.Collator(undefined)